(function () {
  if (window.__extraliebeGemPagesCartFix) return;
  window.__extraliebeGemPagesCartFix = true;

  function visibleBox() {
    return Array.from(document.querySelectorAll('.el-originals-extras')).find(function (box) {
      return box.offsetParent !== null;
    }) || document.querySelector('.el-originals-extras');
  }

  function choiceValue(button) {
    return button && (button.getAttribute('data-hair') || button.getAttribute('data-el-choice'));
  }

  function synchronizeChoice(button) {
    if (!button) return;
    var box = button.closest('.el-originals-extras');
    var value = choiceValue(button);
    if (!box || !value) return;

    box.querySelectorAll('[data-hair], [data-el-choice]').forEach(function (item) {
      if (item !== button) {
        item.classList.remove('is-selected', 'is-active');
        item.setAttribute('aria-pressed', 'false');
      }
    });

    button.setAttribute('data-hair', value);
    button.setAttribute('data-el-choice', value);
    button.classList.add('is-selected', 'is-active');
    button.setAttribute('aria-pressed', 'true');
    box.dataset.hair = value;
  }

  document.addEventListener('click', function (event) {
    var choice = event.target.closest('.el-originals-extras [data-hair], .el-originals-extras [data-el-choice]');
    if (choice) synchronizeChoice(choice);

    var addButton = event.target.closest('button[name="add"], button[aria-label="In den Warenkorb"], .gp-product-button button, gp-product-button button');
    if (!addButton) return;

    var box = visibleBox();
    if (!box) return;

    var selected = box.querySelector('[data-hair].is-selected, [data-el-choice].is-active');
    if (selected) synchronizeChoice(selected);
  }, true);
})();